var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rightBox" }, [
    _c("div", { staticClass: "cockpitBox" }, [
      _c("div", { staticClass: "cockpit_header" }, [
        _c("div", { staticClass: "cockpit_header_bg" }, [
          _c("div", [
            _c("img", {
              attrs: { src: require("@/assets/img/cockpit/deng.png"), alt: "" },
            }),
          ]),
          _c("div", { staticClass: "header_title" }, [_vm._v("项目投诉")]),
          _c("div", [
            _c("img", {
              attrs: { src: require("@/assets/img/cockpit/dian.png"), alt: "" },
            }),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "cockpit_content" },
        [
          _c("div", { staticClass: "row_box" }, [
            _c("div", { staticClass: "row_box_absolute" }),
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/warn/right1.png"),
                alt: "",
              },
            }),
            _c("div", { staticClass: "row_box_dec" }, [_vm._v("待受理")]),
            _c("div", { staticClass: "row_box_val" }, [
              _c("span", [
                _c("span", [_vm._v(_vm._s(_vm.dealStatus("待受理")))]),
              ]),
              _vm._v(" 条 "),
            ]),
          ]),
          _c("div", { staticClass: "row_box" }, [
            _c("div", { staticClass: "row_box_absolute" }),
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/warn/right2.png"),
                alt: "",
              },
            }),
            _c("div", { staticClass: "row_box_dec" }, [_vm._v("已受理")]),
            _c("div", { staticClass: "row_box_detail" }, [
              _c("div", { staticClass: "row_box_detail_row" }, [
                _c("span"),
                _vm._v(" 已办结 "),
                _c("span", [_vm._v(" " + _vm._s(_vm.countArr["已办结"]))]),
              ]),
              _c("div", { staticClass: "row_box_detail_row" }, [
                _c("span"),
                _vm._v(" 未办结 "),
                _c("span", [_vm._v(" " + _vm._s(_vm.countArr["未办结"]))]),
              ]),
              _c("div", { staticClass: "row_box_detail_row" }, [
                _c("span"),
                _vm._v(" 已失效 "),
                _c("span", [_vm._v(" " + _vm._s(_vm.countArr["已失效"]))]),
              ]),
            ]),
            _c("div", { staticClass: "row_box_val row_box_green" }, [
              _c("span", [_vm._v(_vm._s(_vm.dealStatus("已受理")))]),
              _vm._v(" 条 "),
            ]),
          ]),
          _c("div", { staticClass: "row_box" }, [
            _c("div", { staticClass: "row_box_absolute" }),
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/warn/right3.png"),
                alt: "",
              },
            }),
            _c("div", { staticClass: "row_box_dec" }, [_vm._v("不予受理")]),
            _c("div", { staticClass: "row_box_val row_box_gray" }, [
              _c("span", [
                _c("span", [_vm._v(_vm._s(_vm.dealStatus("不予受理")))]),
              ]),
              _vm._v(" 条 "),
            ]),
          ]),
          _c("div", { staticStyle: { "margin-top": "34px" } }, [
            _c("div", { staticClass: "cockpit_content_boxHeader" }, [
              _c("div", { staticClass: "header_cicle" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/cockpit/cicle.png"),
                    alt: "",
                  },
                }),
              ]),
              _c("div", { staticClass: "header_decrit" }, [
                _vm._v("项目类型分布"),
              ]),
              _c("div", { staticClass: "header_line" }),
              _c("div", { staticClass: "header_sanjiao" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/cockpit/sanjiao.png"),
                    alt: "",
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "cockpit_content_boxContent distribution" },
              [
                _c("div", { attrs: { id: "echartsData1" } }),
                _c(
                  "div",
                  { staticClass: "rightFrequency" },
                  _vm._l(_vm.listData, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "rightFrequency_box" },
                      [
                        _c("div", {
                          style: { background: _vm.colorList[index] },
                        }),
                        _c("div", [_vm._v(_vm._s(item.name))]),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.total > 0
                                ? ((item.value / _vm.total) * 100).toFixed(2) +
                                    "%"
                                : 0 + "%"
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]),
          _c(
            "el-carousel",
            { staticClass: "complaints_box", staticStyle: { display: "none" } },
            _vm._l(_vm.complaintsData, function (item, index) {
              return _c("el-carousel-item", { key: index }, [
                _c(
                  "div",
                  {
                    staticClass: "complaints_list",
                    on: {
                      click: function ($event) {
                        return _vm.jumpComplaintsData(item)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "complaints_head" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/cockpit/warn/su.png"),
                          alt: "",
                        },
                      }),
                      _c("div", [_vm._v(_vm._s(item.bidSectionCode))]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "complaints_cotent" },
                      [
                        _c("div", { staticClass: "content-title" }, [
                          _vm._v(_vm._s(item.bidSectionName)),
                        ]),
                        _c("div", { staticClass: "content-flex-row" }, [
                          _c(
                            "span",
                            [_c("icon-svg", { attrs: { name: "code" } })],
                            1
                          ),
                          _c("span", [_vm._v("投诉编号")]),
                          _c("span", [_vm._v(_vm._s(item.complaintCode))]),
                        ]),
                        _c("div", { staticClass: "content-flex-row" }, [
                          _c(
                            "span",
                            [_c("icon-svg", { attrs: { name: "time" } })],
                            1
                          ),
                          _c("span", [_vm._v("投诉时间")]),
                          _c("span", [_vm._v(_vm._s(item.submitTime))]),
                        ]),
                        _c("div", { staticClass: "content-flex-row" }, [
                          _c(
                            "span",
                            [_c("icon-svg", { attrs: { name: "laiyuan" } })],
                            1
                          ),
                          _c("span", [_vm._v("投诉来源")]),
                          _c("span", [_vm._v(_vm._s(item.sourceTypeName))]),
                        ]),
                        _c("div", { staticClass: "content-flex-row" }, [
                          _c(
                            "span",
                            [_c("icon-svg", { attrs: { name: "users" } })],
                            1
                          ),
                          _c("span", [_vm._v("投诉人员")]),
                          _c("span", [_vm._v(_vm._s(item.complainter))]),
                        ]),
                        _c("div", { staticClass: "content-flex-row" }, [
                          _c(
                            "span",
                            [_c("icon-svg", { attrs: { name: "renyuan" } })],
                            1
                          ),
                          _c("span", [_vm._v("被投诉人")]),
                          _c(
                            "div",
                            { staticClass: "right_card" },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    _vm._l(
                                      item.complaintAppellees,
                                      function (items, indexs) {
                                        return _c(
                                          "p",
                                          {
                                            key: indexs,
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(items.entName) +
                                                "（主体类别：" +
                                                _vm._s(items.mainTypeName) +
                                                "）"
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._l(
                                    item.complaintAppellees,
                                    function (items, indexs) {
                                      return _c(
                                        "p",
                                        {
                                          key: indexs,
                                          staticClass: "textOver",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(items.entName) +
                                              "（主体类别：" +
                                              _vm._s(items.mainTypeName) +
                                              "）"
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]),
                        item.receiveStatus == 1
                          ? [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/complaint/dsl.png"),
                                },
                              }),
                            ]
                          : item.receiveStatus == 2
                          ? [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/complaint/bysl.png"),
                                },
                              }),
                            ]
                          : [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/complaint/ysl.png"),
                                },
                              }),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ])
            }),
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }